import { reactive } from 'vue'

import { SECTION_BLOCK, SEARCH_STRINGS_BLOCK } from '../../utils/constants'

import { getDataComponent } from './getDataComponent'

export const store = reactive({
  included: [],
})

export const useData = (
  response: any,
  config: { cmsBasePath: string; cloudname: string; siteLang?: string },
  t: any,
) => {
  // Clear previous data to prevent memory accumulation
  store.included = []
  store.included = response?.included

  if (!response?.included) {
    return []
  }

  // Grouped in one pass, in included order, rather than filtering every entity per section.
  const childrenByParent = new Map<string | undefined, any[]>()
  for (const child of response.included) {
    const parent = child.attributes?.behavior_settings?.layout_paragraphs?.parent_uuid
    const siblings = childrenByParent.get(parent)
    if (siblings) siblings.push(child)
    else childrenByParent.set(parent, [child])
  }

  const getChildren = (id: string) =>
    (childrenByParent.get(id) ?? []).map((item: any) => getDataComponent(item, config, t))

  const sections = response?.included
    .filter((item: any) => item.type === SECTION_BLOCK)
    .map((section: any) => ({
      background: section.attributes.field_background || 'white',
      space: section.attributes.field_space || 'with-space',
      // Optional key used by the front-end section filter (see Custom/section-filter.vue).
      filterKey: section.attributes.field_filter_key || null,
      children: getChildren(section.id),
    }))

  // Also include standalone search strings blocks as sections
  const searchStringsBlocks = response?.included
    .filter((item: any) => item.type === SEARCH_STRINGS_BLOCK)
    .map((searchBlock: any) => ({
      background: 'white',
      space: 'without-space',
      filterKey: null, // search-strings blocks are never section-filtered
      children: [getDataComponent(searchBlock, config, t)],
    }))

  return [...sections, ...searchStringsBlocks]
}
